<template>
  <div class="append-npower-target-form">
    <div class="append-npower-target-form__form">
      <div class="append-target-form__header-menu center">
        <template v-if="title">
          <svg-icon :icon="svg" :width="60" :height="60" class="append-npower-target-form__svg"></svg-icon>
          <div class="text-h4 font-weight-medium pt-2">
            {{ title }}
          </div>
        </template>
      </div>
      <div v-if="loading" class="append-npower-target-form__loading">
        <loading-dots></loading-dots>
      </div>
      <div class="append-npower-target-form__segments" v-show="!loading">
        <h4 class="center">Target: {{target.display_name}}</h4>
        <table class="append-npower-target-form__table">
          <thead>
          <tr>
            <th><span>Quarter</span></th>
            <th><span>Network</span></th>
            <th><span>Half-Hour Records</span></th>
            <th><span>Average UE (000)</span></th>
            <th><span>Uploaded</span></th>
            <th><span>Last Modified By</span></th>
          </tr>
          </thead>
          <tbody>
          <!-- TODO needs to have a key-->
          <tr v-for="s in segments">
            <td><span>{{s.QuarterName}}</span></td>
            <td><span>{{s.NetworkName}}</span></td>
            <td><span>{{s.NumberOfRecords.toLocaleString()}}</span></td>
            <td><span>{{Math.floor(s.AverageUEs/1000).toLocaleString()}}</span></td>
            <td><span>{{new Date(s.UploadedDateTime).toLocaleString()}}</span></td>
            <td><span>{{s.username}}</span></td>
          </tr>
          </tbody>
        </table>
        <div class="append-npower-target-form__upload">
          <v-row justify="space-around">
            <v-col md="4" class="d-flex justify-center align-center">
              <v-file-input
                :accept="acceptedFileFormat"
                ref="fileUploadInput"
                @change="onFileChange"
                v-model="uploadedFile"
                placeholder="No file chosen"
                prepend-icon="mdi-microsoft-excel"
              >
              </v-file-input>
            </v-col>
            <v-col md="4" class="d-flex justify-center align-center">
              <action-button :disabled="!buttonClickable" color="success" id="appendFileModalUploadBtn" label="upload file" @click.native="uploadFile" />
            </v-col>
          </v-row>
        </div>
        <select-segment-modal
          v-if="newSegmentData"
          :fileUploaded="fileLastUploaded"
          :onCompleteSegmentUpload="onClose"
          :segmentData="newSegmentData"
          :currentSegments="segments"
          :uploadedTargetId="target.id"
          :uploadedTargetViewingStream="target.viewing_stream"
        />
        <div v-else-if="isLoadingNewSegments" class="center">
          <loading-dots></loading-dots>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import LoadingDots from '@/components/common/loaderDots'
import SelectSegmentModal from '@/appComponents/targets/createTarget/forms/NpowerSelectSegmentModal'
import RadioButtons from '@/components/common/radioButtons'
import ActionButton from '@/components/common/actionButton'
import {TARGET_TYPE, ACTIVATION_STATUS} from '@/appLogic/targets/Constants'
import {UPLOAD_TARGET_FILE, UPDATE_TARGET_STATUS} from '@/appLogic/targets/createTarget/store/actions'
import {REFRESH_TABLE} from '@/views/audienceHub/store/actions'
import {RESET_TARGET_SEGMENTS, NPOWER_TARGET_UPLOAD_FAILED} from '@/appLogic/targets/currentTarget/store/actions'
import uploadIcon from '@/assets/targetImages/upload.svg'

export default {
  components: {
    SvgIcon,
    LoadingDots,
    SelectSegmentModal,
    RadioButtons,
    ActionButton
  },
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selectedFiles: null,
      newSegmentData: null,
      isLoadingNewSegments: false,
      svg: uploadIcon,
      fileLastUploaded: null,
      uploadedFile: null,
    }
  },
  computed: {
    loading () {
      return this.$store.state.currentTarget.isLoading || this.$store.state.createTarget.isLoading
    },
    segments () {
      return this.$store.getters.segmentData
    },
    target () {
      return this.$store.getters.currentTarget
    },
    acceptedFileFormat () {
      if (this.target.target === TARGET_TYPE.NPOWER || this.target.target === TARGET_TYPE.COMSCORE) {
        return '.xlsx,.xls'
      } else if (this.target.target === TARGET_TYPE.PID) {
        return '.xlsx,.xls,.csv'
      }
    },
    buttonClickable () {
      return this.selectedFiles !== null
    },
    buttonClass () {
      return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive'
    }
  },
  methods: {
    clearSelectedFile () {
      this.uploadedFile = null
      this.selectedFiles = null
    },
    onFileChange (event) {
      if (event instanceof File) {
        this.selectedFiles = [event]
      }
    },
    onClose () {
      this.$store.dispatch(RESET_TARGET_SEGMENTS)
      this.clearSelectedFile()
      this.newSegmentData = null
    },
    scrollToFileInput () {
      const element = this.$refs.fileUploadInput
      // setTimeout(() => element.scrollIntoView(), 100)
    },
    uploadFile () {
      const file = this.selectedFiles[0]
      this.fileLastUploaded = file.name
      const target = this.target
      this.isLoadingNewSegments = true
      this.$store.dispatch(UPLOAD_TARGET_FILE, {target, file, isAppend: true})
        .then(res => {
          this.isLoadingNewSegments = false
          if (res.Error) {
            this.$store.dispatch(NPOWER_TARGET_UPLOAD_FAILED, target.id)
          } else {
            this.newSegmentData = res.irisResponse
          }
        })
    }
  },
  watch: {
    segments (value) {
      if (value > []) this.scrollToFileInput()
    },
    newSegmentData (value) {
      if (value) this.scrollToFileInput()
    }
  }
}
</script>

<style lang="scss">
$currentTargetBackgroundColor: color('grays', 'almost-white');
.append-npower-target-form {
  .center {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .modal__content {
    background-color: $currentTargetBackgroundColor;
  }
  &__table {
    width: 70%;
    margin: auto;
  }
  &__svg {
    float: left;
    margin-right: 20px;
  }
  &__loading {
    width: 100px;
    margin: 0 auto;
  }
  &__segments {
    margin-top: 30px;
    > h4 {
      color: blue;
    }
  }
  &__upload {
    margin: 20px;
    display: flex;
    justify-content: space-evenly;
  }
  &__svg {
    float: left;
    margin-right: 20px;
  }
  &__header-menu {
    height: 100px;
    width: 100%;
    display: flex;
  }
  &__header {
    display: inline-block;
  }
  th {
    background: #d3d3d3;
  }
  td {
    font-weight: normal;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  td, th {
    box-shadow: 0 0 0 1px;
    min-height: 24px;
  }
  @media (min-resolution: 2dppx) {
    td, th {
      box-shadow: 0 0 0 0.5px;
    }
  }
  @media (min-resolution: 3dppx) {
    td, th {
      box-shadow: 0 0 0 0.33333333px;
    }
  }
  @media (min-resolution: 4dppx) {
    td, th {
      box-shadow: 0 0 0 0.25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AppendNPowerForm.vue?096bfb00